import { facultyData } from '../facultyData';

export const economicsData = {
  departmentName: "Department of Economics",
  bannerImage: "/economics/banner.jpg",

  about: {
    title: "About the Department",
    content: `
The Department of Economics at Rayalaseema University offers comprehensive
education in economic theory, policy analysis, and development studies.
The department emphasizes analytical thinking, quantitative skills, and
a strong understanding of socio-economic systems at regional, national,
and global levels.
    `,
    highlights: [
      "Strong focus on Developmental and Regional Economics",
      "Research in public policy and socio-economic development",
      "Training in econometrics and data analysis",
      "Guidance for careers in civil services, research, and academics"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/economics/department-brochure.pdf",
    description: "Download our department brochure."
  },

  hod: {
    id: "eco001",
    name: "Dr. N. T. K. Naik",
    designation: "Professor",
    department: "Economics",
    university: "Rayalaseema University, Kurnool",
    email: "drntknaik@gmail.com",
    mobile: "9440861023",
    photo: "/economics/naik.JPG",
    qualification: "M.A. Economics, Ph.D.",
    specialization: "Agriculture economics, Indian economic policy",
    message: `Welcome to the Department of Economics at Rayalaseema University. 
The department is committed to providing high-quality education and research 
in economics with a strong focus on analytical thinking, policy understanding, 
and socio-economic development.

Our academic programmes are designed to equip students with a sound foundation 
in economic theory, quantitative methods, and applied economics, enabling them 
to critically analyze real-world economic issues at regional, national, and 
global levels. The department encourages research, innovation, and interdisciplinary 
learning to address contemporary economic challenges.

We strive to nurture socially responsible graduates who can contribute effectively 
to public policy formulation, research institutions, academia, civil services, 
and the corporate sector. With a dedicated faculty and a supportive academic 
environment, the Department of Economics continuously works towards academic 
excellence and meaningful societal impact.`,

    profileLink: "/economics/NTK-NAIK.pdf"
  },

  bos: {
  title: "Economics",
  members: [
    {
      name: "Prof. N.T.K Naik",
      designation: "Chairperson",
      affiliation: "Dept. of Economics, Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. G. Venkata Naidu",
      designation: "Member",
      affiliation: "Dept. of Economics, S.K. University, Anantapur"
    },
    {
      name: "Prof. B. Srinivasulu",
      designation: "Member",
      affiliation: "Dept. of Economics, Yogi Vemana University, Kadapa & Registrar, Dr. Abdul Haq Urdu University, Kurnool"
    },
    {
      name: "Prof. S. Suresh Lal",
      designation: "Member",
      affiliation: "Dept. of Economics, Kakatiya University, Warangal"
    },
    {
      name: "Sri Prahlada Setty",
      designation: "Member",
      affiliation: "Managing Director, Rayalaseema Alkalis Chemicals, Kurnool"
    }
  ]
}
,

  faculty: facultyData.economics.faculty,

  courses: {
    // undergraduate: [
    //   {
    //     name: "B.A. Economics",
    //     duration: "3 Years",
    //     eligibility: "10+2",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "M.A. Economics",
        duration: "2 Years",
        eligibility: "B.A. Economics",
        intake: "30 seats"
      }
    ],
    research: [
      {
        name: "Ph.D. in Economics",
        duration: "Minimum 3 Years",
        eligibility: "M.A. Economics",
        areas: "Development Economics, Econometrics, Public Economics"
      }
    ]
  },

  Infrastructure: [
    
  ]
};